/* eslint-disable no-param-reassign */
import Vue from 'vue';

const ValidationPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $rules() {
          return {
            required: value => !!value || "Kenttä on pakollinen.",
            email: email => {
              let re = /\S+@\S+\.\S+/;
              return !!re.test(String(email).toLowerCase()) || "Sähköpostiosoite ei ole kelvollinen.";
            },
            spacesNotAllowed: value => !(value && value.indexOf(' ') > -1) || "Kentässä ei saa olla välilyöntejä.",
            passwordHasToMatch: (value, match) => value === match || "Uudet salasanat eivät täsmää.",
            mustBeAtLeast6Characters: value =>
                (!!value && value.length > 5) || "Salasanan pitää olla vähintään 6 merkkiä pitkä.",
          };
        },
      }
    });
  }
}

export default ValidationPlugin;